import { Map } from 'immutable';
import { createContext } from 'react';

export enum OrganizationExportImportContextAction {
  UpdateExportState,
  UpdateImportState,
}

export enum OrganizationExportState {
  Available,
  Busy,
}

export interface OrganizationExportItem {
  state: OrganizationExportState;
  promise: Promise<any>;
}

export interface OrganizationImportItem {
  promise: Promise<any> | undefined;
  state: OrganizationExportState;
}

export interface OrganizationExportImportContextType {
  exportState: Map<string, OrganizationExportItem>;
  importState: OrganizationImportItem;
}

export interface OrganizationExportImportStateModifier {
  type: OrganizationExportImportContextAction;
  organizationId: string;
  state: OrganizationExportState;
  promise: Promise<any>;
}

export const organizationExportImportContextInitialData: OrganizationExportImportContextType = {
  exportState: Map<string, OrganizationExportItem>(),
  importState: { promise: undefined, state: OrganizationExportState.Available },
};

export const organizationExportImportReducer = (state: OrganizationExportImportContextType, action: OrganizationExportImportStateModifier) => {
  switch (action.type) {
    case OrganizationExportImportContextAction.UpdateExportState: {
      const item: OrganizationExportItem = {
        promise: action.promise,
        state: action.state,
      };
      state.exportState = state.exportState.set(action.organizationId, item);
      break;
    }
    case OrganizationExportImportContextAction.UpdateImportState: {
      const item: OrganizationImportItem = { promise: action.promise, state: action.state };
      state.importState = item;
    }
  }
  return state;
};

export const OrganizationExportImportContext = createContext({
  organizationExportState: organizationExportImportContextInitialData,
  organizationExportDispatch: (modifier: OrganizationExportImportStateModifier) => {},
});
